import styled from 'styled-components'

import { LANDING_MAX_CONTENT_WIDTH_PX } from 'Constants/Landing'

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-width: ${LANDING_MAX_CONTENT_WIDTH_PX}px;
`
